import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "../../lib/utils";

const Avatar = React.forwardRef(
  ({ className, ...props }, ref) => (
    <AvatarPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
        className
      )}
      {...props}
    />
  )
);
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef(
  ({ className, src, alt, onError, ...props }, ref) => {
    const [imageError, setImageError] = React.useState(false);
    const [imageSrc, setImageSrc] = React.useState(src);

    // Reset error state when src changes
    React.useEffect(() => {
      setImageError(false);
      setImageSrc(src);
    }, [src]);

    const handleError = () => {
      setImageError(true);
      if (onError) {
        onError();
      }
    };

    // Don't render image if there was an error or no src
    if (imageError || !imageSrc) {
      return null;
    }

    return (
      <AvatarPrimitive.Image
        ref={ref}
        src={imageSrc}
        alt={alt}
        onError={handleError}
        className={cn("aspect-square h-full w-full", className)}
        // Add loading optimization for Google images
        loading="lazy"
        decoding="async"
        crossOrigin="anonymous"
        {...props}
      />
    );
  }
);
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef(
  ({ className, ...props }, ref) => (
    <AvatarPrimitive.Fallback
      ref={ref}
      className={cn(
        "flex h-full w-full items-center justify-center rounded-full bg-muted",
        className
      )}
      {...props}
    />
  )
);
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarImage, AvatarFallback }; 